'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var EmptyParametersModel = Nested.Model.extend({});

exports.default = EmptyParametersModel;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/paged/EmptyParametersModel.js
// module id = 1415
// module chunks = 118